// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"397":"3dae804f","498":"c2bea05b","525":"73fb5f90","555":"7c96a572"}[chunkId] + ".chunk.js";
};